import React, { useState, useRef, useEffect } from 'react';
import { Input } from './input';

const toDraft = (v) => (v === undefined || v === null || v === '' ? '' : String(v));

// Controlled number input that lets the user clear the field while typing.
// Commits numeric values via onValueChange; coerces empty/invalid to emptyValue on blur.
const NumberInput = React.forwardRef(({ value, onValueChange, emptyValue = 0, min, max, onFocus, onBlur, ...props }, ref) => {
  const [draft, setDraft] = useState(toDraft(value));
  const focusedRef = useRef(false);

  useEffect(() => {
    if (!focusedRef.current) setDraft(toDraft(value));
  }, [value]);

  const clamp = (n) => {
    if (min !== undefined && min !== null && n < Number(min)) return Number(min);
    if (max !== undefined && max !== null && n > Number(max)) return Number(max);
    return n;
  };

  return (
    <Input
      ref={ref}
      type="number"
      min={min}
      max={max}
      {...props}
      value={draft}
      onFocus={(e) => { focusedRef.current = true; if (onFocus) onFocus(e); }}
      onChange={(e) => {
        const raw = e.target.value;
        setDraft(raw);
        if (raw === '' || raw === '-') return;
        const n = Number(raw);
        if (!Number.isNaN(n)) onValueChange(clamp(n));
      }}
      onBlur={(e) => {
        focusedRef.current = false;
        const n = Number(draft);
        const final = draft === '' || Number.isNaN(n) ? emptyValue : clamp(n);
        setDraft(toDraft(final));
        onValueChange(final);
        if (onBlur) onBlur(e);
      }}
    />
  );
});
NumberInput.displayName = 'NumberInput';

export { NumberInput };
